import * as React from "react";
const ExportTag = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M5.55978 20.4001L11.5998 26.4401C14.0798 28.9201 18.1064 28.9201 20.5998 26.4401L26.4531 20.5867C28.9331 18.1067 28.9331 14.0801 26.4531 11.5867L20.3998 5.56007C19.1331 4.2934 17.3864 3.6134 15.5998 3.70673L8.93311 4.02673C6.26644 4.14673 4.14644 6.26673 4.01311 8.92007L3.69311 15.5867C3.61311 17.3867 4.29311 19.1334 5.55978 20.4001Z"
        fill="#344054"
      />
      <path
        d="M5.55978 20.4001L11.5998 26.4401C14.0798 28.9201 18.1064 28.9201 20.5998 26.4401L26.4531 20.5867C28.9331 18.1067 28.9331 14.0801 26.4531 11.5867L20.3998 5.56007C19.1331 4.2934 17.3864 3.6134 15.5998 3.70673L8.93311 4.02673C6.26644 4.14673 4.14644 6.26673 4.01311 8.92007L3.69311 15.5867C3.61311 17.3867 4.29311 19.1334 5.55978 20.4001Z"
        fill="url(#paint0_linear_3639_300849)"
      />
      <path
        d="M5.55978 20.4001L11.5998 26.4401C14.0798 28.9201 18.1064 28.9201 20.5998 26.4401L26.4531 20.5867C28.9331 18.1067 28.9331 14.0801 26.4531 11.5867L20.3998 5.56007C19.1331 4.2934 17.3864 3.6134 15.5998 3.70673L8.93311 4.02673C6.26644 4.14673 4.14644 6.26673 4.01311 8.92007L3.69311 15.5867C3.61311 17.3867 4.29311 19.1334 5.55978 20.4001Z"
        fill="url(#paint1_linear_3639_300849)"
      />
      <path
        d="M5.55978 20.4001L11.5998 26.4401C14.0798 28.9201 18.1064 28.9201 20.5998 26.4401L26.4531 20.5867C28.9331 18.1067 28.9331 14.0801 26.4531 11.5867L20.3998 5.56007C19.1331 4.2934 17.3864 3.6134 15.5998 3.70673L8.93311 4.02673C6.26644 4.14673 4.14644 6.26673 4.01311 8.92007L3.69311 15.5867C3.61311 17.3867 4.29311 19.1334 5.55978 20.4001Z"
        fill="url(#paint2_linear_3639_300849)"
      />
      <path
        d="M5.55978 20.4001L11.5998 26.4401C14.0798 28.9201 18.1064 28.9201 20.5998 26.4401L26.4531 20.5867C28.9331 18.1067 28.9331 14.0801 26.4531 11.5867L20.3998 5.56007C19.1331 4.2934 17.3864 3.6134 15.5998 3.70673L8.93311 4.02673C6.26644 4.14673 4.14644 6.26673 4.01311 8.92007L3.69311 15.5867C3.61311 17.3867 4.29311 19.1334 5.55978 20.4001Z"
        fill="url(#paint3_linear_3639_300849)"
      />
    </g>
    <path
      d="M12.6664 16.5067C14.7872 16.5067 16.5064 14.7874 16.5064 12.6667C16.5064 10.5459 14.7872 8.82666 12.6664 8.82666C10.5456 8.82666 8.82642 10.5459 8.82642 12.6667C8.82642 14.7874 10.5456 16.5067 12.6664 16.5067Z"
      fill="#344054"
    />
    <path
      d="M12.6664 16.5067C14.7872 16.5067 16.5064 14.7874 16.5064 12.6667C16.5064 10.5459 14.7872 8.82666 12.6664 8.82666C10.5456 8.82666 8.82642 10.5459 8.82642 12.6667C8.82642 14.7874 10.5456 16.5067 12.6664 16.5067Z"
      fill="url(#paint4_linear_3639_300849)"
    />
    <path
      d="M12.6664 16.5067C14.7872 16.5067 16.5064 14.7874 16.5064 12.6667C16.5064 10.5459 14.7872 8.82666 12.6664 8.82666C10.5456 8.82666 8.82642 10.5459 8.82642 12.6667C8.82642 14.7874 10.5456 16.5067 12.6664 16.5067Z"
      fill="url(#paint5_linear_3639_300849)"
    />
    <path
      d="M12.6664 16.5067C14.7872 16.5067 16.5064 14.7874 16.5064 12.6667C16.5064 10.5459 14.7872 8.82666 12.6664 8.82666C10.5456 8.82666 8.82642 10.5459 8.82642 12.6667C8.82642 14.7874 10.5456 16.5067 12.6664 16.5067Z"
      fill="url(#paint6_linear_3639_300849)"
    />
    <path
      d="M12.6664 16.5067C14.7872 16.5067 16.5064 14.7874 16.5064 12.6667C16.5064 10.5459 14.7872 8.82666 12.6664 8.82666C10.5456 8.82666 8.82642 10.5459 8.82642 12.6667C8.82642 14.7874 10.5456 16.5067 12.6664 16.5067Z"
      fill="url(#paint7_linear_3639_300849)"
    />
    <path
      d="M17.3331 23.6664C17.0798 23.6664 16.8264 23.5731 16.6264 23.3731C16.2398 22.9864 16.2398 22.3464 16.6264 21.9598L21.9598 16.6264C22.3464 16.2398 22.9864 16.2398 23.3731 16.6264C23.7598 17.0131 23.7598 17.6531 23.3731 18.0398L18.0398 23.3731C17.8398 23.5731 17.5864 23.6664 17.3331 23.6664Z"
      fill="#344054"
    />
    <path
      d="M17.3331 23.6664C17.0798 23.6664 16.8264 23.5731 16.6264 23.3731C16.2398 22.9864 16.2398 22.3464 16.6264 21.9598L21.9598 16.6264C22.3464 16.2398 22.9864 16.2398 23.3731 16.6264C23.7598 17.0131 23.7598 17.6531 23.3731 18.0398L18.0398 23.3731C17.8398 23.5731 17.5864 23.6664 17.3331 23.6664Z"
      fill="url(#paint8_linear_3639_300849)"
    />
    <path
      d="M17.3331 23.6664C17.0798 23.6664 16.8264 23.5731 16.6264 23.3731C16.2398 22.9864 16.2398 22.3464 16.6264 21.9598L21.9598 16.6264C22.3464 16.2398 22.9864 16.2398 23.3731 16.6264C23.7598 17.0131 23.7598 17.6531 23.3731 18.0398L18.0398 23.3731C17.8398 23.5731 17.5864 23.6664 17.3331 23.6664Z"
      fill="url(#paint9_linear_3639_300849)"
    />
    <path
      d="M17.3331 23.6664C17.0798 23.6664 16.8264 23.5731 16.6264 23.3731C16.2398 22.9864 16.2398 22.3464 16.6264 21.9598L21.9598 16.6264C22.3464 16.2398 22.9864 16.2398 23.3731 16.6264C23.7598 17.0131 23.7598 17.6531 23.3731 18.0398L18.0398 23.3731C17.8398 23.5731 17.5864 23.6664 17.3331 23.6664Z"
      fill="url(#paint10_linear_3639_300849)"
    />
    <path
      d="M17.3331 23.6664C17.0798 23.6664 16.8264 23.5731 16.6264 23.3731C16.2398 22.9864 16.2398 22.3464 16.6264 21.9598L21.9598 16.6264C22.3464 16.2398 22.9864 16.2398 23.3731 16.6264C23.7598 17.0131 23.7598 17.6531 23.3731 18.0398L18.0398 23.3731C17.8398 23.5731 17.5864 23.6664 17.3331 23.6664Z"
      fill="url(#paint11_linear_3639_300849)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300849"
        x1={28.3131}
        y1={28.3001}
        x2={28.3131}
        y2={3.69824}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A7A6CB" />
        <stop offset={1} stopColor="#8989BA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300849"
        x1={3.68638}
        y1={28.2999}
        x2={28.2883}
        y2={3.67343}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#39A0FF" />
        <stop offset={1} stopColor="#8FFF85" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300849"
        x1={40.6263}
        y1={15.9992}
        x2={16.0245}
        y2={-8.62718}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#764BA2" />
        <stop offset={1} stopColor="#667EEA" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300849"
        x1={3.68677}
        y1={3.69824}
        x2={28.2886}
        y2={28.3246}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#89F7FE" />
        <stop offset={1} stopColor="#66A6FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3639_300849"
        x1={16.5064}
        y1={16.5067}
        x2={16.5064}
        y2={8.82666}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A7A6CB" />
        <stop offset={1} stopColor="#8989BA" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3639_300849"
        x1={8.8263}
        y1={16.5066}
        x2={16.5063}
        y2={8.82657}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#39A0FF" />
        <stop offset={1} stopColor="#8FFF85" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3639_300849"
        x1={20.3464}
        y1={12.6667}
        x2={12.6664}
        y2={4.98666}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#764BA2" />
        <stop offset={1} stopColor="#667EEA" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3639_300849"
        x1={8.82642}
        y1={8.82666}
        x2={16.5064}
        y2={16.5067}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#89F7FE" />
        <stop offset={1} stopColor="#66A6FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3639_300849"
        x1={23.6631}
        y1={23.6664}
        x2={23.6631}
        y2={16.3364}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A7A6CB" />
        <stop offset={1} stopColor="#8989BA" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3639_300849"
        x1={16.3363}
        y1={23.6664}
        x2={23.6663}
        y2={16.3397}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#39A0FF" />
        <stop offset={1} stopColor="#8FFF85" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3639_300849"
        x1={27.3264}
        y1={20.0014}
        x2={19.9964}
        y2={12.6748}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#764BA2" />
        <stop offset={1} stopColor="#667EEA" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3639_300849"
        x1={16.3364}
        y1={16.3364}
        x2={23.6664}
        y2={23.6631}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#89F7FE" />
        <stop offset={1} stopColor="#66A6FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default ExportTag;
